import { useNavigate } from 'react-router-dom';

import { Grid } from '@mui/material';

import PageCard from '@/components/PageCard';
import { SYSTEM_USER_PAGES } from '@/constants/system-user-pages';
import { useAuthorization } from '@/hooks/auth';

export default function SystemUsers() {
  const navigate = useNavigate();
  const { checkUserHasRole } = useAuthorization();

  return (
    <Grid
      container
      spacing={2}
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      {SYSTEM_USER_PAGES.menuItems.map(
        ({ icon: Icon, path, title, showOnNavMenus, roles }) => {
          if (
            (showOnNavMenus !== undefined && !showOnNavMenus) ||
            (roles && !checkUserHasRole(roles))
          ) {
            return null;
          }
          return (
            <Grid key={path} item onClick={() => navigate(path)}>
              <PageCard path={path} title={title} CardIcon={Icon} />
            </Grid>
          );
        }
      )}
    </Grid>
  );
}
